import { render } from "./AccessAuthentication.vue?vue&type=template&id=0dd7b458"
import script from "./AccessAuthentication.vue?vue&type=script&lang=js"
export * from "./AccessAuthentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__